import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import * as service from "./service";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import TopTrendingEpisodes from "../../Components/TopTrending/TopTrendingEpisodes";
import RedeemBanner from './Components/HomeSlider/RedeemBanner';
import Categories from './Components/Categories';
import MoreTopics from "./Components/GaiaSlider/MoreTopics";
import GaiaGenres from "./Components/GaiaSlider/GaiaGenres";
import LiveChannels2 from "../LiveChannels/LiveChannels2";
const Homepage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);

  const [loading, setLoading] = useState(true);
  const [homeData, setHomeData] = useState([]);
  const [homeDataSliceCount, setHomeDataSliceCount] = useState(8);

  const homePageContainerRef = useRef();
  const scrollPosition = useScrollPosition();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const location = useLocation();
  const params = useParams();
  const key = location?.state?.key || params?.key;

  useEffect(() => {
    if (!loading && homeDataSliceCount < homeData?.length) {
      lazyLoad();
    }
  }, [loading, scrollPosition, homeData]);

  useEffect(() => {
    window.scroll(0, 0);
    setLoading(true);
    fetchShowDetails();
  }, [user, key]);
  const fetchShowDetails = async () => {
    try {
      const response = await service.getShowsByCategory(appInfo, key);
      if (response?.status === 200) {
        setHomeData(response?.data?.data);
        setLoading(false);
      }
    } catch {
      setLoading(true);
    }
  };

  const lazyLoad = () => {
    const containerHeight = homePageContainerRef?.current?.clientHeight;
    if (scrollPosition + 2500 >= containerHeight) {
      setHomeDataSliceCount(homeDataSliceCount + 5);
    }
  };

  if (loading) {
    return <Loading />;
  }

  const firstItem = homeData[0]?.type;

  return (
    <div
      className={"homePage"}
      style={
        firstItem !== "FEATURED" && firstItem !== "LIVE"
          ? { paddingTop: "100px" }
          : {}
      }
      ref={homePageContainerRef}
    >
      {homeData?.map((item, index) => {
        if (item?.type === "LIVE") {
          return (
            <LiveChannels2
              key={"livechannels-homepage"}
              hideEpg={true}
              channelId={item?.shows?.[0]?.channel_id}
            />
          );
        } else if (item?.type === "FEATURED") {
          return <RedeemBanner key={index} data={item} />;
        }

        if (item?.type === "TOP_TRENDING") {
          return <TopTrendingEpisodes data={item} type={item?.type} />;
        } else if (item?.type === "GENRES") {
          return <GaiaGenres data={item} />;
        } else if (item?.type === "MORE_TOPICS") {
          return <MoreTopics data={item} />;
        } else if (item?.type !== "FEATURED" && item?.type !== "LIVE") {
          return <Categories key={index} data={item} />;
        }
      })}
    </div>
  );
};

export default Homepage;
